/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OpenTabSummaryDto } from '../../models/open-tab-summary-dto';

export interface PosTabsControllerFindOpenTabs$Params {

/**
 * Filter by session ID (if omitted, returns all open tabs)
 */
  sessionId?: string;

/**
 * Search by visitor alias or user name
 */
  search?: string;
}

export function posTabsControllerFindOpenTabs(http: HttpClient, rootUrl: string, params?: PosTabsControllerFindOpenTabs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OpenTabSummaryDto>>> {
  const rb = new RequestBuilder(rootUrl, posTabsControllerFindOpenTabs.PATH, 'get');
  if (params) {
    rb.query('sessionId', params.sessionId, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OpenTabSummaryDto>>;
    })
  );
}

posTabsControllerFindOpenTabs.PATH = '/pos/tabs/open';
